import script from "./PriceCompanyRow.vue?vue&type=script&setup=true&lang=js"
export * from "./PriceCompanyRow.vue?vue&type=script&setup=true&lang=js"

import "./PriceCompanyRow.vue?vue&type=style&index=0&id=227146b0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-227146b0"]])

export default __exports__